import {
  useContext,
  useEffect,
  useState
} from 'react';
import {
  ELSPropsFromModalService,
  ELSWithModalService
} from '@els/els-component-modal-react';
import { flowRight } from 'lodash';
import { useLocation } from 'react-router';
import { Location } from 'history';
import {
  ELSCommonUIConstants,
} from '@els/els-ui-common-react';
import { AdobeLoginStatus } from '../../models/adobe-analytics.models';
import {
  convertPathToName,
  getRoutePathByPath,
  RouteConfig,
  RouteConfigMap
} from '../app/app.routes';
import { captureNewPageDataAction } from '../app/app-state-actions.utilities';
import { RecordEmpty } from '../../models/common.models';
import { AppContext } from '../app/AppProvider.component';

export type LocationChangeHandlerProps = ELSPropsFromModalService;

export const LocationChangeHandlerComponent = (props: LocationChangeHandlerProps): JSX.Element => {

  const [lastLoggedRoute, setLastLoggedRoute] = useState<string>(null);

  const location: Location = useLocation();
  const { appState, setAppState, appStateRef } = useContext(AppContext);

  useEffect(() => {
    props.modalService.closeAllModal();
    // A recommendation launch (isLaunchingRecommendation) should never remain
    // true across a route change — e.g. the user hits browser back before the
    // external app redirect fires, which would otherwise leave the page loader
    // stuck on forever since nothing else clears it once the screen is gone.
    setAppState((prevState) => ({
      ...prevState,
      isLaunchingRecommendation: false
    }));
  }, [location]);

  useEffect(() => {

    const route = getRoutePathByPath(location.pathname);
    const config: RouteConfig = RouteConfigMap[route];

    if (config?.isPrivate && window.pageData.visitor.loginStatus !== AdobeLoginStatus.LOGGED_IN) {
      return;
    }

    if (lastLoggedRoute === location.pathname) {
      return;
    }

    setLastLoggedRoute(location.pathname);

    captureNewPageDataAction({
      setAppState,
      appState,
      appStateRef,
      pageData: {
        page: {
          loadTimestamp: new Date().getTime().toString(),
          name: config ? config.data.analytics.pageName : convertPathToName(location.pathname),
          type: config ? config.data.analytics.pageType : ELSCommonUIConstants.analytics.pageTypes.genericNav,
        }
      }
    });

  }, [location.pathname, window.pageData.visitor.loginStatus]);

  return null;
};

const enhance = flowRight(ELSWithModalService);

export default enhance(LocationChangeHandlerComponent) as React.FC<RecordEmpty>;
